export default class CartAddButton extends HTMLElement {
    constructor() {
        super();
        this.cartNotification = document.querySelector('cart-notification');
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const cartItems = document.querySelector('cart-items');
            if (cartItems) {
                cartItems.addProduct(this.dataset.id, 1);
            } else {
                this.addProduct(this.dataset.id, 1);
            }
        });
    }
    addProduct(id, quantity) {
        this.setAttribute('aria-disabled', 'true');
        this.classList.add('loading');

        const properties = {};
        if (this.dataset.purchaseType) {
            properties['_purchase_type'] = this.dataset.purchaseType;
        }

        const body = JSON.stringify({
            id,
            quantity,
            properties,
            sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
        });


        fetch(`${window.routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this.handleErrorMessage(response.description);
                    return;
                }

                this.cartNotification.renderContents(response);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                this.classList.remove('loading');
                this.removeAttribute('aria-disabled');
                this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                this.classList.toggle('is-empty', response.item_count === 0);
            });
    }
}

